const Footer = () => (
  <footer className="footer">
    <p>
      Created by
      <a href="https://github.com/Owusu-Desmond">
        {' '}
        <i> Desmond Owusu Ansah</i>
      </a>
      . The source code is licensed
      <a href="https://github.com/Owusu-Desmond/math-magicians/blob/dev/LICENSE"> MIT</a>
    </p>
    <p> &copy; 2022 - Math Magicians App || All rights all reserved</p>
  </footer>
);

export default Footer;
